import React from "react";
import axios from "axios";
import TimeAgo from "../TimeAgo";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { decrementUnseen } from "../../../app/slices/userSlice";
import { apiUrl } from "../../../utils/backendUrl";
import styles from "./Notification.module.css";

function Notification({ toast, t, notification }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const markAsRead = () => {
    if (notification?._id) {
      axios
        .patch(
          apiUrl(`/api/v1/notifications/${notification._id}/read`),
          {},
          { withCredentials: true }
        )
        .then(() => {
          dispatch(decrementUnseen({ type: "notification" }));
        })
        .catch(() => {});
    }
  };

  const handleDismiss = () => {
    markAsRead();
    toast.dismiss(t.id);
  };

  const stopDismissEvent = (event) => {
    event.stopPropagation();
  };

  // Admin broadcasts (and other server-generated notifications) arrive
  // without `click`/`_id`; a toast tap must then only dismiss, never
  // navigate(undefined).
  const target = notification?.click || "";
  const content = notification?.content || notification?.message || "";
  const reactType =
    notification?.type === "react"
      ? `${content}`.split(" ")[2] || "like"
      : notification?.type || "notification";

  return (
    <div
      className={`${styles.main}`}
      data-testid="notification-toast"
      data-notification-type={notification?.type || ""}
    >
      <div className={styles.header}>
        <span>New notification</span>
        <button
          type="button"
          aria-label="Dismiss notification toast"
          title="Dismiss notification"
          data-testid="notification-toast-dismiss"
          onPointerDown={stopDismissEvent}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleDismiss();
          }}
          className={`small_circle ${styles.dismissButton}`}
        >
          <span aria-hidden="true" className={styles.dismissGlyph}>
            ×
          </span>
        </button>
      </div>
      <div
        className={styles.content}
        data-testid="notification-toast-open"
        onClick={() => {
          markAsRead();
          toast.dismiss(t.id);
          if (target) navigate(target);
        }}
      >
        <div className={styles.img}>
          <img
            src={notification?.sender?.photo || notification?.actor?.photo || "/images/default_pic.png"}
            alt=""
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/images/default_pic.png";
            }}
          />
          <img
            className={styles.type}
            src={`../../../reacts/${reactType}.svg`}
            alt=""
          />
        </div>
        <div className={styles.content_2}>
          <span>{content}</span>
          <span className={styles.time}>
            <TimeAgo interval={30}>
              {notification?.createdAt}
            </TimeAgo>
          </span>
        </div>
        <div>
          <p
            style={{
              background: `#0096ff`,
              width: "12px",
              height: "12px",
              borderRadius: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Notification;
